module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_3.9d043d7d.png";